import AtSymbolIcon from '@heroicons/react/outline/AtSymbolIcon'
import ChatIcon from '@heroicons/react/outline/ChatIcon'
import CogIcon from '@heroicons/react/outline/CogIcon'
import UserIcon from '@heroicons/react/outline/UserIcon'
import ViewGridIcon from '@heroicons/react/outline/ViewGridIcon'

import { I18nShape } from '@tribeplatform/react-components/i18n'

export const ConfirmEmailStep = (
  intl: I18nShape,
  completed: boolean,
  action: () => void,
) => ({
  order: 10,
  id: 'confirm-email',
  title: intl.$t({
    defaultMessage: 'Confirm your email',
    id: 'Onboarding.Verify.Title',
  }),
  description: intl.$t({
    defaultMessage: 'Verify your identity.',
    id: 'Onboarding.Verify.Description',
  }),
  icon: AtSymbolIcon,
  completed,
  button: {
    cta: intl.$t({
      defaultMessage: 'Confirm',
      id: 'Generics.Confirm',
    }),
    completed: intl.$t({
      defaultMessage: 'Confirmed',
      id: 'Onboarding.Verify.Done',
    }),
    variant: 'primary',
    action,
  },
})

export const UploadLogoStep = (
  intl: I18nShape,
  completed: boolean,
  action: () => void,
) => ({
  order: 20,
  title: intl.$t({
    defaultMessage: 'Upload your logo',
    id: 'Onboarding.Logo.Title',
  }),
  id: 'upload-logo',
  description: intl.$t({
    defaultMessage: 'Upload community logo and set access level.',
    id: 'Onboarding.Logo.Description',
  }),
  icon: CogIcon,
  completed,
  button: {
    cta: intl.$t({
      defaultMessage: 'Setup',
      id: 'Onboarding.Logo.CTA',
    }),
    completed: intl.$t({
      defaultMessage: 'Done',
      id: 'Generics.Done',
    }),
    variant: 'outline',
    action,
  },
})

export const StructureStep = (
  intl: I18nShape,
  completed: boolean,
  action: () => void,
) => ({
  order: 30,
  title: intl.$t({
    defaultMessage: 'Define structure',
    id: 'Onboarding.Structure.Title',
  }),
  id: 'create-space',
  description: intl.$t({
    defaultMessage: 'Create {COLLECTIONS} and {SPACES}',
    id: 'Onboarding.Structure.Description',
  }),
  icon: ViewGridIcon,
  completed,
  button: {
    cta: intl.$t({
      defaultMessage: 'Create {SPACE}',
      id: 'Onboarding.Structure.CTA',
    }),
    completed: intl.$t({
      defaultMessage: 'Created',
      id: 'Generics.Created',
    }),
    variant: 'outline',
    action,
  },
})

export const ProfileStep = (
  intl: I18nShape,
  completed: boolean,
  action: () => void,
) => ({
  order: 40,
  title: intl.$t({
    defaultMessage: 'Update your profile',
    id: 'Onboarding.Profile.Title',
  }),
  id: 'update-profile',
  description: intl.$t({
    defaultMessage: 'Add your photo and tagline.',
    id: 'Onboarding.Profile.Description',
  }),
  icon: UserIcon,
  completed,
  button: {
    cta: intl.$t({
      defaultMessage: 'Update',
      id: 'Generics.Update',
    }),
    completed: intl.$t({
      defaultMessage: 'Updated',
      id: 'Generics.Updated',
    }),
    action,
  },
})

export const CreatePostStep = (
  intl: I18nShape,
  completed: boolean,
  action: () => void,
) => ({
  order: 50,
  title: intl.$t({
    defaultMessage: 'Create a post',
    id: 'Onboarding.Post.Title',
  }),
  id: 'create-post',
  description: intl.$t({
    defaultMessage: 'Engage with the community.',
    id: 'Onboarding.Post.Description',
  }),
  icon: ChatIcon,
  completed,
  button: {
    cta: intl.$t({
      defaultMessage: 'Create post',
      id: 'Onboarding.Post.CTA',
    }),
    completed: intl.$t({
      defaultMessage: 'Done',
      id: 'Generics.Done',
    }),
    action,
  },
})
